// project import
import dashboard from './dashboard-items';

import HRMenuItems from 'modules/hr/layout/HRMenuItems';
import UserMenuItems from 'modules/hr/layout/UserMenuItems';
import SettingMenuItems from 'modules/settings/layout/SettingMenuItems';

import DiagnosticsMenuItems from 'modules/diagnostics/layout/DiagnosticsMenuItems';
import SupportMenuItems from 'modules/support/layout/SupportMenuItems';

// types
import { NavItemType } from 'layout/mantis/types/MenuType';
import { useState } from 'react';
import CourseMenuItems from 'modules/core/layout/CourseMenuItems';
import BatchMenuItems from 'modules/core/layout/BatchMenuItems';
import ExamBankMenuItems from 'modules/core/layout/ExamBankMenuItems';
import ReportsMenuItems from 'modules/core/layout/ReportsMenuItems';
import CertificationMenuItems from 'modules/core/layout/CertificationMenuItems';
import CommunicationMenuItems from 'modules/core/layout/CommunicationMenuItems';

// ==============================|| MENU ITEMS ||============================== //

export default function _menuItems() {
	let render = <></>;

	const [courseItems, setCourseItems] = useState<NavItemType>(CourseMenuItems());
	const [batchItems, setbatchItems] = useState<NavItemType>(BatchMenuItems());
	const [communicationItems, setcommunicationItems] = useState<NavItemType>(CommunicationMenuItems());
	const [examBankItems, setExamBankItems] = useState<NavItemType>(ExamBankMenuItems());
	const [certificationItems, setCertificationItems] = useState<NavItemType>(CertificationMenuItems());
	const [reportsItems, setReportsItems] = useState<NavItemType>(ReportsMenuItems());
	const [hrItems, setHrItems] = useState<NavItemType>(HRMenuItems());
	const [userItems, setUserItems] = useState<NavItemType>(UserMenuItems());
	const [settingItems, setSettingItems] = useState<NavItemType>(SettingMenuItems());
	const [diagnosticsItems, setDiagnosticsItems] = useState<NavItemType>(DiagnosticsMenuItems());
	const [supportItems, setSupportItems] = useState<NavItemType>(SupportMenuItems());

	let items = [];

	items.push(dashboard);

	if (Object.keys(userItems).length > 0) items.push(userItems);

	// if (Object.keys(batchItems).length > 0) items.push(batchItems);

	if (Object.keys(communicationItems).length > 0) items.push(communicationItems);

	if (Object.keys(courseItems).length > 0) items.push(courseItems);

	if (Object.keys(examBankItems).length > 0) items.push(examBankItems);

	if (Object.keys(certificationItems).length > 0) items.push(certificationItems);

	if (Object.keys(reportsItems).length > 0) items.push(reportsItems);

	

	// if (Object.keys(hrItems).length > 0)
	//     items.push(hrItems);

	if (Object.keys(settingItems).length > 0) items.push(settingItems);

	// if (Object.keys(diagnosticsItems).length > 0)
	//     items.push(diagnosticsItems);

	if (Object.keys(supportItems).length > 0)
	    items.push(supportItems);

	return { render, items };
}
